import {RoleRegisterForm} from './components/RoleRegisterForm'
import {RoleEditForm} from './components/RoleEditForm'
import {Modal, Card} from 'react-bootstrap'
import {KTIcon} from '../../../_metronic/helpers'
import {ModeleModule} from '../../../components/Models'

type Props = {
  show: boolean
  isEdition: boolean
  roleId?: Number | undefined
  showModal: () => void
  handleClose: () => void
  addDataRole?: () => void
  updateDataRole?: () => void
  modules: ModeleModule[]
  loading: () => void
}

const RoleModal = ({
  show,
  isEdition,
  roleId,
  showModal,
  addDataRole,
  updateDataRole,
  modules,
  loading,
}) => {
  return (
    <>
      <Modal
        size='lg'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        show={show}
      >
        <div className='modal-content shadow-none'>
          <div className='modal-header'>
            <h5 className='modal-title'>{isEdition ? 'Modification rôle' : 'Ajouter un nouveau rôle'}</h5>

            <div
              className='btn btn-icon btn-sm btn-light-primary ms-2'
              onClick={() => showModal(false)}
            >
              <KTIcon className='fs-2' iconName='cross' />
            </div>
          </div>
          <div className='modal-body'>
            {!isEdition && (
              <RoleRegisterForm
                showModalProp={showModal}
                addDataRole={addDataRole}
                modulesInitial={modules}
                setLoadingProp={loading}
              />
            )}
            {isEdition && (
              <RoleEditForm
                roleId={roleId}
                showModalProp={showModal}
                updateDataRole={updateDataRole}
                modulesInitial={modules}
                setLoadingProp={loading}
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  )
}
export {RoleModal}
